/**
 * Reveals fullText in small steps (ChatGPT-style) for non-streaming APIs.
 * @returns {{ cancel: () => void }}
 */
export function startChatTypewriter({ fullText, onTick, onComplete, onStoppedPartial }) {
  let idx = 0;
  let timer = null;
  let cancelled = false;
  const charStep = 2;
  const intervalMs = 22;

  const finishComplete = () => {
    if (timer) clearInterval(timer);
    timer = null;
    onComplete();
  };

  timer = setInterval(() => {
    if (cancelled) return;
    idx = Math.min(idx + charStep, fullText.length);
    onTick(fullText.slice(0, idx));
    if (idx >= fullText.length) {
      finishComplete();
    }
  }, intervalMs);

  return {
    cancel: () => {
      if (cancelled) return;
      cancelled = true;
      if (timer) clearInterval(timer);
      timer = null;
      const partial = fullText.slice(0, idx);
      if (partial.length < fullText.length) onStoppedPartial(partial);
      else onComplete();
    },
  };
}
